import axios from 'axios'
import i18n from '../plugins/i18n'

export default {
  getTranslations() {
    axios.defaults.baseURL = process.env.VUE_APP_BACK_URL

    return axios.get('/ru/api/public/translations')
  },
  getData() {
    return axios.get(`${i18n.locale}/api/public/data`)
  }
}
